import baseAxios from "../axios-service";

export default {
  getRound(programId, cycleId, timeId, roundId) {
    return baseAxios.get(
      `/programs/${programId}/cycles/${cycleId}/days-and-weeks/${timeId}/rounds/${roundId}`
    );
  }
};
